import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';
import classNames from 'classnames';

import { MESSAGING_URL } from 'global-constants';

import { getConversationName } from 'pages/Messaging/Conversation/utils';
import {
  requestCreateConversation,
  setCurrentConversation,
  fetchInitialConversationMessages
} from 'pages/Messaging/ducks';

import WithUser from 'shared/HOCs/WithUser';

import Button from 'shared/components/Button';

import styles from './styles.module.scss';

class MessageButton extends React.Component {
  handleClick = () => {
    const {
      handleUnsigned,
      push,
      user,
      setCurrentConversation,
      fetchInitialConversationMessages,
      requestCreateConversation,
      target,
      buttonAdditionalActions = []
    } = this.props;

    if (_.isEmpty(user || _.isNil(user))) return handleUnsigned();

    const extra = [
      nonce => push(MESSAGING_URL),
      conversation =>
        setCurrentConversation({
          id: conversation.id,
          participants: conversation.participants,
          name: getConversationName({
            ...conversation,
            currentUserId: user.id
          })
        }),
      conversation => fetchInitialConversationMessages(conversation.id),
      () => buttonAdditionalActions.map(action => action())
    ];
    requestCreateConversation([target.slug], extra);
  };

  render() {
    const {
      user,
      target,
      className,
      isIcon = true,
      color = 'turquoise',
      buttonText = 'Message',
      disabled = false
    } = this.props;

    const isSameUser = _.get(target, 'slug') === _.get(user, 'slug', -1);

    return isIcon ? (
      <div
        className={classNames(styles.messageIcon, className, 'material-icons')}
        onClick={this.handleClick}>
        mail_outline
      </div>
    ) : (
      <Button
        color={color}
        onClick={this.handleClick}
        disabled={disabled || isSameUser}
        className={classNames(styles.messageBtn, className)}>
        {buttonText}
      </Button>
    );
  }
}

const mapDispatchToProps = {
  push,
  setCurrentConversation,
  fetchInitialConversationMessages,
  requestCreateConversation
};

export default WithUser(
  connect(
    null,
    mapDispatchToProps
  )(MessageButton)
);
